<template>
    <!-- 分享录播页面 -->
    <div>
      <v-downTip :popShow="popShow" ></v-downTip>
      <div class="pwdbox" v-if="pwdflag">
          <img src="../images/pwdboxbg.png" alt="">
          <p>
            <input type="text" v-model="password" placeholder="请输入密码观看录播">
          </p>
          <div class="pwdbut" @click="pwdsubmit">确&nbsp;&nbsp;&nbsp;&nbsp;定</div>
      </div>
      <div class="coverBox" :style="{height: height}" v-if="!pwdflag && isShowCoverImg">
          <img class="coverImg" :src="pageData.coverImg"/>
          <img @click="palyVideo()" class="palyImg" src="../images/playButton.png"/>
          <div class="shadowBox"></div>
      </div>
      <div class="liveWrap" :style="{height: height, backgroundColor: '#000'}" v-if="!pwdflag">
          <video ref="video" preload controls="controls" :style="!pageData.isUploadRecord ? {objectFit: 'cover'} : ''" :src="pageData.destinationPath" webkit-playsinline playsinline x5-video-player-type="h5" x5-video-orientation="h5" x5-playsinline x-webkit-airplay airplay="allow"></video>
          <!-- <div class="closeButton" @click="handleClose"><img src="../images/closeButton.png" /></div> -->
          <!-- <div id="myVideo" :style="{height: '100%'}"></div> -->
          <!-- <video ref="video" preload controls="controls" webkit-playsinline playsinline x-webkit-airplay="allow" :src="pageData.destinationPath"></video> -->
          <!-- </div> -->
          <div class="userBox">
              <img class="headImg" :src="pageData.headImage ? pageData.headImage : require('../images/headerImg.png')" />
              <span class="userName">{{pageData.userName}}</span>
              <span class="attentionBtn" @click="toAttention()"><img src="../images/guanzhu.png"/></span>
          </div>
      </div>
    </div>
</template>
<script>
import '../js/flexible.debug.js'
import global from "../js/global.js"
import weixin from "../js/weixinall.js"
export default {
  data () {
    return {
      popShow:false,
      Rtcp:'',
      shareSwiper:'',
      pubId:'',
      height:'',
      pageData:'',
      password: '', // 录播密码`
      pwdflag: false,
      isShowCoverImg: true,
      aaa: {}
    }
  },
  created(){
  },
  mounted(){
    this.height = window.outerHeight+'px'
    weixin.shareInfo(19,this.$route.query.contentId,this.$route.query.accountId)
    weixin.shareTitle(19,this.$route.query.contentId,(data)=>{
      // console.log(data)
      this.shareSwiper = data;
    })
    this.init()
    
  },
  methods:{
    // 获取初始化 数据
    init(){
      this.$http.get("/content/unsecured/get/live/record?contentId="+this.$route.query.contentId).then( res => {
        if(res.respCode === 1){
            this.pageData = res.respData
            this.pwdflag = res.respData.password
        }
      })
    },
    // 点击播放视频
    palyVideo () {
      this.isShowCoverImg = false
      // this.player.play()
      this.$refs.video.play()
      // let video = this.$refs.video
      // console.log(video.videoWidth)
      // console.log(video.videoHeight)
      // console.log(window.outerHeight)
      // console.log(window.outerWidth)
    },
    // 去 关注
    toAttention () {
        this.popShow = global.toStore(this.shareSwiper)
    },
    pwdsubmit(){
      if(this.pageData.password == this.password){
        this.pwdflag = false
      } else { // 密码输入错误
        // this.$Message.warning({
        //   content: '密码错误,请重新输入!',
        //   duration: 100
        // })
        this.$toast('密码错误,请重新输入!');
        this.password = ''
      }
    },
    // 关闭窗口
    // handleClose () {
    //   WeixinJSBridge.call('closeWindow')
    // }
 }
}
</script>

<style lang="less">
    .ivu-message{
        span{
            font-size: 28px;
        }
        .ivu-icon-android-alert{
           vertical-align: top;
           margin-top: 10px;
        }
    }
</style>

<style scoped lang="less">
    .ivu-message{
      span{
        font-size: 32px;
      }
    }
    .coverBox{
      z-index: 9;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      .shadowBox{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 9;
        background-color: rgba(0,0,0,.6);
      }
      .coverImg{
        width: 100%;
        height: 100%;
        filter: blur(10px);           
      }

      .palyImg{
        z-index: 10;
        position: absolute;
        width: 320px;
        height: 320px;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

    }
    .liveWrap{
        position: relative;
        z-index: 1;

        video{
          height: 100%;
          width: 100%;
        }

        .closeButton {
            position: absolute;
            height: 68px;
            width: 68px;
            top: 100px;
            right: 20px;

            img{
                display: block;
                width: 100%;
                height: 100%;
            }
        }

        .userBox {
            position: absolute;
            height: 80px;
            top: 94px;
            left: 20px;
            // opacity: .45;
            background-color: rgba(0,0,0,.45);
            border-radius: 40px;
            z-index: 999;

            .headImg {
                width: 64px;
                height: 64px;
                margin-left: 8px;
                margin-top: 8px;
                border-radius: 50%;
                vertical-align: middle;
            }

            span{
                vertical-align: middle;
                margin-left: 10px;
                margin-top: 10px;
                font-family: PingFangSC-Semibold;
                font-size: 28px;
                color: #FFFFFF;
            }

            span.attentionBtn{
                display: inline-block;
                height: 48px;
                width: 96px;
                margin-right: 20px;
                margin-left: 30px;
                // border-radius: 10px;

                img{
                  display: block;
                  width: 100%;
                  height: 100%;
                }
            }
        }
    }
    .pwdbox{
        img{
          display: block;
          width: 294px;
          height: 280px;
          margin:160px auto 0;
        }
        p{
          height: 44px;
          margin:0 auto;
          width: 654px;
          margin-top:106px;
          background: url(../images/pwdicon.png) 0 0 no-repeat;
          background-size: 44px 44px;
          border-bottom:1px solid #E6E6E6;
          padding-left: 72px;
          padding-bottom: 66px;
            input{
              width:100%;
              border: 0;  // 去除未选中状态边框
              outline: none; // 去除选中状态边框
              font-size: 32px;
              background-color: rgba(0, 0, 0, 0);// 透明背景
            }
        }
        .pwdbut{
          background-image: linear-gradient(90deg, #EF4B4B 4%, #F7643C 100%);
          box-shadow: 0 32px 48px -32px #F35744;
          border-radius: 44px;
          display: block;
          font-size: 32px;
          color: #fff;
          text-align: center;
          width: 400px;
          height: 88px;
          line-height: 88px;
          margin: 120px auto 0;
          cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/share/shareRecordBroadcast.vue